import { triggerLink } from 'common/util'
import classes from 'classnames'
import styles from './index.module.scss'

interface IFeatureProps {
  icon?: string
  id: number
  title: string
  value: string
  art_id: string
  layout: string
  befortrigger?: () => void
}

const Feature = ({
  id,
  icon,
  value: url,
  title,
  art_id,
  layout,
  befortrigger,
}: IFeatureProps) => {

  const openLink = () => {
    if (!url) return
    befortrigger && befortrigger()
    const link = url.includes('?') ? `${url}&entry_id=${art_id}` : `${url}?entry_id=${art_id}`
    triggerLink(link)
  }

  return (
    <div className={classes(styles.cell, styles[layout])} onClick={openLink}>
      {icon && <i style={{ backgroundImage: `url(${icon})` }}></i>}
      <span className={styles.title}>{title}</span>
      <i className={styles.arrow}></i>
    </div>
  )
}

export default Feature
